import { ref, VNode } from 'vue'
import { useI18n } from 'vue-i18n'
import { BSVariant } from '@/config'

const DEFAULT_TIMEOUT = 5000

type DefaultVariants = 'danger' | 'success'
export interface ToastOptions {
  id?: string
  text?: string
  variant?: BSVariant | 'notification'
  timeout?: number
  customHTML?: string
  customVNode?: VNode
  autohide?: boolean
}

export interface Toast extends ToastOptions {
  // These are optional in the options because we can provide default values for them, but when adding the Toast these values should be set
  id: string
  variant: BSVariant | 'notification'
  timeout: number
  autohide: boolean
}

const toasts = ref<Toast[]>([])

export function addToast({
  text,
  variant = 'primary',
  timeout = DEFAULT_TIMEOUT,
  autohide = true,
  customHTML,
  customVNode,
}: ToastOptions) {
  pushToast({ id: `toast-${Date.now()}`, text, variant, timeout, customHTML, customVNode, autohide })
}

function pushToast(toast: Toast) {
  toasts.value = [...toasts.value, toast]
}

export default function useToasts() {
  const { t } = useI18n()

  function addDefaultToast(variant: DefaultVariants) {
    let text = ''
    switch (variant) {
      case 'success':
        text = t('Action successful')
        break
      case 'danger':
        text = t('An unexpected error happened')
        break
    }
    pushToast({
      id: `toast-${Date.now()}`,
      text,
      variant,
      timeout: DEFAULT_TIMEOUT,
      autohide: true,
    })
  }

  function clearToast(id: string) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function clearAllNotifications() {
    toasts.value = toasts.value.filter((t) => t.variant !== 'notification')
  }

  return { toasts, addToast, clearToast, addDefaultToast, clearAllNotifications }
}
